module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0zNjAtMTIwcS0xMDAgMC0xNzAtNzB0LTcwLTE3MHYtMjQwcTAtMTAwIDcwLTE3MHQxNzAtNzBoMjQwcTEwMCAwIDE3MCA3MHQ3MCAxNzB2MjQwcTAgMTAwLTcwIDE3MHQtMTcwIDcwSDM2MFptODAtMjAwIDI0MC0yNDAtNTYtNTYtMTg0IDE4NC04OC04OC01NiA1NiAxNDQgMTQ0Wm0tODAgMTIwaDI0MHE2NiAwIDExMy00N3Q0Ny0xMTN2LTI0MHEwLTY2LTQ3LTExM3QtMTEzLTQ3SDM2MHEtNjYgMC0xMTMgNDd0LTQ3IDExM3YyNDBxMCA2NiA0NyAxMTN0MTEzIDQ3Wm0xMjAtMjgwWiIgZmlsbD0iIzcwQTFGMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/priority-24px-active.svg
// module id = NdwN
// module chunks = 1